import { render, staticRenderFns } from "./HomeAddressPage.vue?vue&type=template&id=1d48d993&"
import script from "./HomeAddressPage.vue?vue&type=script&lang=js&"
export * from "./HomeAddressPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports